<template>
  <div class="container-fluid">
    <div v-if="Object.keys(allocationList).length > 0" class="row">
      <div class="col-12 show-hide-presets" @click="togglePresets()">
        <div class="row">
          <div class="col-9">
            <h5>{{ $t("Menu.list.allocations.predefined.title") }}</h5>
          </div>
          <div class="col-3 text-end">
            <img
              :src="appUrl + '/img/icons/edit.svg'"
              class="icon open"
              v-if="showPresets === false"
              alt="edit"
            />
            <img
              :src="appUrl + '/img/icons/close.svg'"
              class="icon"
              v-if="showPresets === true"
              alt="close"
            />
          </div>
        </div>
      </div>
      <div class="col-12" v-if="showPresets === true">
        <ul class="default-option-list">
          <template v-for="(item, index) in allocationList">
            <li
              v-bind:key="index"
              @click="changeItem(item.itemnumber, item.alerts)"
              :class="{ match: item.match }"
            >
              <img
                class="thumb"
                :src="
                  appUrl +
                  '/img/assets/allocations/' +
                  index.substr(1, 9) +
                  '.jpg'
                "
                :srcset="
                  appUrl +
                  '/img/assets/allocations/' +
                  index.substr(1, 9) +
                  '@2x.jpg'
                "
                :alt="item.text"
              />
              <p class="allocation-name">{{ item.text }}</p>
            </li>
          </template>
          <li v-if="!all" @click="all = true" class="pointer">
            <img class="thumb" :src="appUrl + '/img/icons/next.svg'" />
            {{ $t("Menu.list.allocations.more") }} &gt;
          </li>
        </ul>
      </div>
    </div>
    <div class="row" v-if="possibleItems.list.discs">
      <div class="col-12">
        <div v-if="Object.keys(allocationList).length > 0">
          <hr />
          <br />
        </div>
        <h5>{{ $t("Menu.list.allocations.individual.title") }}</h5>
        <br />
        <div class="container-fluid disc-list">
          <template v-for="(disc, discId) in possibleItems.list.discs.discs">
            <div class="row" v-bind:key="'discs' + discId">
              <div class="col-2 text-start">
                <img
                  class="thumb"
                  :src="
                    $parent.getFinishIcon(
                      disc.surface,
                      disc.alloy,
                      set.items[0].itemnumber,
                      false
                    )
                  "
                  :srcset="
                    $parent.getFinishIcon(
                      disc.surface,
                      disc.alloy,
                      set.items[0].itemnumber,
                      true
                    )
                  "
                  alt=""
                />
              </div>
              <div class="col-8">
                <template
                  v-if="possibleItems.list.discs.separations[discId + 1]"
                >
                  <select
                    class="form-control"
                    @change="
                      changeItemByVarValue(
                        '7_' +
                          (discId + 1) +
                          '_' +
                          Math.round($event.target.value * 100) +
                          '_no'
                      )
                    "
                  >
                    <option
                      v-for="step in getSteplist(
                        possibleItems.list.discs.separations[discId + 1]
                          .pos_start,
                        possibleItems.list.discs.separations[discId + 1].pos_end
                      )"
                      :selected="
                        isSelectedInStepList(
                          discId + 1,
                          step.pos,
                          possibleItems.list.discs.position,
                          false
                        )
                      "
                      v-bind:key="step.pos"
                      :value="step.pos"
                    >
                      <template
                        v-if="possibleItems.list.discs.position === 'vertical'"
                        >{{ $t("Set.Item.Description.width") }}</template
                      >
                      <template v-else>{{
                        $t("Set.Item.Description.height")
                      }}</template>
                      {{
                        $n(
                          getDiscForStep(
                            step.value,
                            discId,
                            possibleItems.list.discs.position,
                            false
                          ),
                          "mm"
                        )
                      }}
                      ({{ $t("Menu.list.allocations.till") }}
                      {{ $n(step.value, "mm") }} mm)
                    </option>
                  </select>
                </template>
                <p v-else>
                  <span v-if="possibleItems.list.discs.position !== 'vertical'">
                    {{ $t("Set.Item.Description.height") }}
                    {{ $n(disc.height, "mm") }} mm
                  </span>
                  <span v-else>
                    {{ $t("Set.Item.Description.width") }}
                    {{ $n(disc.width, "mm") }} mm
                  </span>
                  ({{ $t("Menu.list.allocations.till") }}
                  {{
                    getLastTillWidthOrHeightOfDisc(
                      possibleItems.list.discs.position,
                      false
                    )
                  }}
                  mm)
                </p>
              </div>
              <div
                class="col-2"
                v-if="possibleItems.list.discs.separations[discId + 1]"
              >
                <img
                  :src="appUrl + '/img/icons/close.svg'"
                  class="icon"
                  @click="changeItemByVarValue('16_' + (discId + 1) + '_left')"
                />
              </div>
            </div>
            <div
              class="row add-line"
              v-bind:key="'add' + discId"
              v-if="
                isAddDiscAllowed &&
                disc.width >= 1 &&
                possibleItems.list.discs.position !== 'horizontal'
              "
              @click="changeItemByVarValue('15_' + (discId + 1) + '_1')"
            >
              <div class="col-2 text-center">
                <img :src="appUrl + '/img/icons/add.svg'" class="icon" />
              </div>
              <div class="col-10 text-start">
                <p>{{ $t("Menu.list.allocations.individual.add") }}</p>
              </div>
            </div>
            <br v-else v-bind:key="'add' + discId" />
          </template>
        </div>
        <div
          v-if="possibleItems.list.discs.position === 'horizontal'"
          class="container-fluid disc-list"
        >
          <template
            v-if="
              possibleItems.list.discs.addPartition.discs &&
              possibleItems.list.discs.addPartition.discs.length > 0
            "
          >
            <hr />
            <br />
            <template
              v-for="(disc, discId) in possibleItems.list.discs.addPartition
                .discs"
            >
              <div
                v-if="
                  possibleItems.list.discs.position === 'horizontal' &&
                  disc.width > 0
                "
                class="row"
                v-bind:key="'discs' + discId"
              >
                <div class="col-2 text-start">
                  <img
                    class="thumb"
                    :src="
                      $parent.getFinishIcon(
                        disc.surface,
                        disc.alloy,
                        set.items[0].itemnumber,
                        false
                      )
                    "
                    :srcset="
                      $parent.getFinishIcon(
                        disc.surface,
                        disc.alloy,
                        set.items[0].itemnumber,
                        true
                      )
                    "
                    alt=""
                  />
                </div>
                <div class="col-8 text-center">
                  <template
                    v-if="
                      possibleItems.list.discs.addPartition.separations[
                        discId + 1
                      ]
                    "
                  >
                    <select
                      class="form-control text-end"
                      @change="
                        changeItemByVarValue(
                          '7_' +
                            (discId + 1) +
                            '_' +
                            Math.round($event.target.value * 100) +
                            '_no'
                        )
                      "
                    >
                      <option
                        v-for="step in getSteplist(
                          possibleItems.list.discs.addPartition.separations[
                            discId + 1
                          ].pos_start,
                          possibleItems.list.discs.addPartition.separations[
                            discId + 1
                          ].pos_end
                        )"
                        :selected="
                          isSelectedInStepList(
                            discId + 1,
                            step.pos,
                            possibleItems.list.discs.addPartition.position,
                            true
                          )
                        "
                        v-bind:key="step.pos"
                        :value="step.pos"
                      >
                        <template
                          v-if="
                            possibleItems.list.discs.addPartition.position ===
                            'vertical'
                          "
                          >{{ $t("Set.Item.Description.width") }}</template
                        >
                        <template v-else>{{
                          $t("Set.Item.Description.height")
                        }}</template>
                        {{
                          $n(
                            getDiscForStep(
                              step.value,
                              discId,
                              possibleItems.list.discs.addPartition.position,
                              true
                            ),
                            "mm"
                          )
                        }}
                        ({{ $t("Menu.list.allocations.till") }}
                        {{ $n(step.value, "mm") }} mm)
                      </option>
                    </select>
                  </template>
                  <p v-else>
                    <span
                      v-if="
                        possibleItems.list.discs.addPartition.position !==
                        'vertical'
                      "
                    >
                      {{ $t("Set.Item.Description.height") }}
                      {{ $n(disc.height, "mm") }} mm
                    </span>
                    <span v-else>
                      {{ $t("Set.Item.Description.width") }}
                      {{ $n(disc.width, "mm") }} mm
                    </span>
                    ({{ $t("Menu.list.allocations.till") }}
                    {{
                      getLastTillWidthOrHeightOfDisc(
                        possibleItems.list.discs.addPartition.position,
                        true
                      )
                    }}
                    mm)
                  </p>
                </div>
                <div
                  class="col-2"
                  v-if="
                    possibleItems.list.discs.addPartition.separations[
                      discId + 1
                    ]
                  "
                >
                  <img
                    :src="appUrl + '/img/icons/close.svg'"
                    class="icon"
                    @click="
                      changeItemByVarValue('16_' + (discId + 1) + '_left')
                    "
                  />
                </div>
              </div>
              <div
                class="row add-line"
                v-bind:key="'add' + discId"
                v-if="
                  isAddDiscAllowed &&
                  disc.width >= 1 &&
                  possibleItems.list.discs.addPartition.position !==
                    'horizontal'
                "
                @click="changeItemByVarValue('15_' + (discId + 1) + '_1')"
              >
                <div class="col-2 text-center">
                  <img :src="appUrl + '/img/icons/add.svg'" class="icon" />
                </div>
                <div class="col-10 text-start">
                  <p>{{ $t("Menu.list.allocations.individual.add") }}</p>
                </div>
              </div>
              <br v-else v-bind:key="'add' + discId" />
            </template>
          </template>
          <div
            v-else-if="possibleItems.list.discs.position === 'horizontal'"
            class="row"
          >
            <div class="col-12">
              <a class="btn btn-block" @click="changeItemByVarValue('15_1')">{{
                $t("Menu.list.allocations.individual.verticalAdd")
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ hidden: !isAllactionDragNdrop }" class="row">
      <div id="SeparationPlan" ref="SeparationPlan" class="col-12 text-center">
        <div id="SeparationParts">
          <template v-if="verticalDiscsAvailable">
            <template
              v-for="(separation, separationId) in getVerticalSeparations"
            >
              <div
                v-bind:key="'separation' + separationId"
                class="separation"
                draggable="true"
                @dragstart="separationDragStart($event)"
                @dragend="separationDragEnd($event)"
                @dragover="separationDragOver($event, false)"
                @touchstart="separationDragStart($event)"
                @touchend="separationDragEnd($event)"
                @touchmove="separationDragOver($event, false)"
                :data-id="separationId"
                :style="{
                  left: getSeparationPosLeft(separation.px_start) + 'px',
                  width: getSeparationWidth(separationId, false) + 'px',
                  height:
                    getSeparationHeight(
                      possibleItems.list.discs.heightPx,
                      false
                    ) + 'px',
                }"
                :ref="'separation' + separationId"
              >
                T{{ separationId }}
              </div>
              <div
                v-if="parseInt(separationId) < getTotalSeparations"
                v-bind:key="'disc' + separationId"
                class="disc"
                draggable="true"
                @dragstart="separationDragStart($event)"
                @dragend="separationDragEnd($event)"
                @dragover="separationDragOver($event, true)"
                @touchstart="separationDragStart($event)"
                @touchend="separationDragEnd($event)"
                @touchmove="separationDragOver($event, true)"
                :data-id="separationId"
                :style="{
                  left: getSeparationPosLeft(separation.px_start) + 'px',
                  width: getSeparationWidth(separationId, true) + 'px',
                  height:
                    getSeparationHeight(
                      possibleItems.list.discs.heightPx,
                      true
                    ) + 'px',
                }"
                :ref="'disc' + separationId"
              ></div>
            </template>
          </template>
          <img
            class="profile-plan"
            :src="
              getApiHost +
              '/v2/images/profile/' +
              getItemnumberForPlan() +
              '.jpg'
            "
            alt=""
            ref="profile-plan"
            width="100%"
          />
        </div>
      </div>
      <div id="discWidthWrapper" class="col-12 text-center">
        <template v-for="(disc, discId) in getVerticalDiscs">
          <span
            class="new-disc-width"
            v-if="disc.width > 0"
            style="display: inline-block; margin-top: 2rem; text-align: center"
            :style="
              'width:' +
              (
                300 /
                (getVerticalDiscs[0].width == 0
                  ? getVerticalDiscs.length - 1
                  : getVerticalDiscs.length)
              ).toFixed(0) +
              'px;'
            "
            :ref="'discWidth' + discId"
            v-bind:key="'discWidth' + discId"
          >
            {{ $n(disc.width, "mm") }}
          </span>
        </template>
      </div>
      <img
        alt=""
        id="DragDropIcon"
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
        ref="DragDropIcon"
      />
    </div>
  </div>
</template>

<script>
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";

export default {
  name: "VariationsAllocations",
  props: ["possibleItems"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      getApiHost: Config.getters.getApiHost,
      itemData: SetData.getters.getCurrentItem,
      currentItemId: SetData.getters.getCurrentItemId,
      set: SetData.getters.getSet,
      separations: [],
      separationAddLeft: 25,
      separationFactor: 1,
      separationPosStart: null, // x or y
      currentSeparationNode: null,
      all: true,
      maxItems: 6,
      showPresets: true,
    };
  },
  methods: {
    togglePresets: function () {
      if (this.showPresets === true) {
        this.showPresets = false;
      } else {
        this.showPresets = true;
      }
    },
    changeItem: function (itemnumber, alerts) {
      this.$parent.$parent.changeItem(itemnumber, alerts);
    },
    changeItemByVarValue: function (varValue) {
      this.$parent.$parent.changeItemByVarValue(varValue);
    },
    getDiscForStep: function (step, discId, position, isAddPartition) {
      let discForStep = step;
      let discList = this.possibleItems.list.discs.discs;
      if (isAddPartition === true) {
        discList = this.possibleItems.list.discs.addPartition.discs;
      }
      if (discList[discId - 1]) {
        for (let i in discList) {
          if (i < discId) {
            if (position === "vertical") {
              discForStep -= discList[i].width;
            } else {
              discForStep -= discList[i].height;
            }
          }
        }
      }
      return discForStep;
    },
    previewDiscForStep: function (posInMM, separationId, isDisc) {
      if (isDisc !== true) {
        let isAddPartition =
          this.possibleItems.list.discs.position === "horizontal";

        posInMM = parseFloat(posInMM);
        let discForStep = this.getDiscForStep(
          posInMM,
          separationId - 1,
          "vertical",
          isAddPartition
        );

        let discNode = this.$refs["discWidth" + (separationId - 1)];
        if (discNode) {
          discNode[0].innerHTML = discForStep.toFixed(2);
        }
      }
    },
    getSteplist: function (from, till) {
      let list = [];

      from = parseFloat(from.toFixed(2));
      till = parseFloat(till.toFixed(2));

      for (let i = from; i <= till; i += 0.05) {
        i = parseFloat(i.toFixed(2));
        list.push({
          pos: i,
          value: i,
        });
      }
      return list;
    },
    isSelectedInStepList: function (discId, step, position, isAddPartition) {
      let value = "";
      if (
        isAddPartition === false &&
        this.possibleItems.list.discs.separations[1]
      ) {
        if (position === "horizontal") {
          value = parseFloat(
            this.possibleItems.list.discs.separations[1].height
          ); // horizontal
        } else {
          value = parseFloat(
            this.possibleItems.list.discs.separations[1].width
          ); // vertical
        }
      } else if (this.possibleItems.list.discs.addPartition.separations[1]) {
        if (position === "horizontal") {
          value = parseFloat(
            this.possibleItems.list.discs.addPartition.separations[1].height
          ); // horizontal
        } else {
          value = parseFloat(
            this.possibleItems.list.discs.addPartition.separations[1].width
          ); // vertical
        }
      }
      if (discId > 1) {
        let separations = this.possibleItems.list.discs.separations;
        if (isAddPartition === true) {
          separations = this.possibleItems.list.discs.addPartition.separations;
        }
        value = 0;
        for (let numericKey in separations) {
          if (numericKey <= discId) {
            if (position === "horizontal") {
              value += parseFloat(separations[numericKey].height);
            } else {
              value += parseFloat(separations[numericKey].width);
            }
          }
        }
        value = value.toFixed(2);
      }

      return value == step ? true : false;
    },
    getLastTillWidthOrHeightOfDisc: function (position, isAddPartition) {
      let lastTill = 0;
      if (
        this.possibleItems.list.discs &&
        this.possibleItems.list.discs.discs
      ) {
        let discList = this.possibleItems.list.discs.discs;
        if (isAddPartition === true) {
          discList = this.possibleItems.list.discs.addPartition.discs;
        }
        for (let numericKey in discList) {
          if (position === "vertical") {
            lastTill += discList[numericKey].width;
          } else {
            lastTill += discList[numericKey].height;
          }
        }
      }
      return Math.round(lastTill * 100) / 100;
    },
    setSeparationStartValues: function () {
      let itemWidth = parseFloat(
        this.set.items[0].description.width.toString().replace(",", ".")
      );

      if (this.itemData.description) {
        itemWidth = parseFloat(
          this.itemData.description.width.toString().replace(",", ".")
        );
      }
      this.separationFactor = 299 / itemWidth;

      let separations = this.possibleItems.list.discs.separations;
      if (
        this.possibleItems.list.discs.position === "horizontal" &&
        this.possibleItems.list.discs.addPartition.discs.length > 0
      ) {
        separations = this.possibleItems.list.discs.addPartition.separations;
      }

      for (let separationId in separations) {
        let data = separations[separationId];
        this.separations[separationId] = {
          left: this.getSeparationPosLeft(data.px_start),
          width: data.width,
          sideGroove: data.side_groove,
          posMin: data.pos_start,
          posMax: data.pos_end,
        };
      }
    },
    getSeparationPosLeft: function (pxStart) {
      pxStart += this.separationAddLeft;
      return pxStart;
    },
    getSeparationWidth: function (separationId, isDisc) {
      let separations;
      if (this.possibleItems.list.discs.position === "vertical") {
        separations = this.possibleItems.list.discs.separations;
      } else {
        separations = this.possibleItems.list.discs.addPartition.separations;
      }

      let separationWidth = parseFloat(separations[separationId].width);

      if (separations[parseInt(separationId) + 1]) {
        separationWidth = parseFloat(
          separations[parseInt(separationId) + 1].width
        );
      }

      if (isDisc !== true) {
        separationWidth = (separationWidth / 2.5).toFixed(2);
      }

      separationWidth *= this.separationFactor;
      separationWidth -= 6;

      return parseInt(separationWidth.toString());
    },
    getSeparationHeight: function (pxHeight, isDisc) {
      return isDisc === true ? parseInt(pxHeight) : parseInt(pxHeight) + 40;
    },
    separationDragStart: function (e) {
      e.stopPropagation();
      e.target.style.width = "20rem";
      if (e.dataTransfer) {
        e.dataTransfer.setDragImage(this.$refs.DragDropIcon, 0, 0);
      }

      this.currentSeparationNode =
        e.target.classList[0] + e.target.getAttribute("data-id");
      this.separationPosStart =
        e.target.getBoundingClientRect().x + this.separationAddLeft;
    },
    separationDragEnd: function (e) {
      e.stopPropagation();

      this.separationPosStart = null;
      this.currentSeparationNode = null;

      let separationId = e.target.getAttribute("data-id");
      let separationNode = e.target.classList[0];

      let posInMM =
        parseFloat(this.$refs["separation" + separationId][0].innerHTML) * 100;

      if (!isNaN(posInMM)) {
        let varValue =
          "7_" +
          separationId +
          "_" +
          posInMM +
          (separationNode == "disc" ? "_yes" : "_no");
        this.changeItemByVarValue(varValue);
      }
    },
    separationDragOver: function (e, isDisc) {
      e.stopPropagation();
      e.target.style.cursor = "move";

      if (this.separationPosStart == null) {
        return;
      }

      let separationId = e.target.getAttribute("data-id");
      let separationNode = e.target.classList[0];

      if (this.currentSeparationNode !== separationNode + separationId) {
        return;
      }

      let posMax = this.separations[separationId].posMax;

      let nextSeparation = null;
      let nextSeparationId = parseInt(separationId) + 1;
      if (this.separations[nextSeparationId] && isDisc === true) {
        nextSeparation = this.separations[nextSeparationId];
        posMax = nextSeparation.posMax;
        posMax -= nextSeparation.width;
      }

      let clientX = e.clientX ? e.clientX : e.touches[0].clientX;
      let newPos =
        clientX - this.separationPosStart + this.separations[separationId].left;
      let posInMM =
        Math.ceil(
          ((newPos - this.separationAddLeft) / this.separationFactor) * 20
        ) / 20;

      let stopDragNDrop = false;

      if (posInMM < this.separations[separationId].posMin) {
        posInMM = this.separations[separationId].posMin.toFixed(2);
        stopDragNDrop = true;

        this.$refs["separation" + separationId][0].innerHTML = posInMM;
        this.previewDiscForStep(posInMM, separationId, isDisc);
      } else if (posInMM > posMax) {
        posInMM = posMax.toFixed(2);
        stopDragNDrop = true;

        this.$refs["separation" + separationId][0].innerHTML = posInMM;
        this.previewDiscForStep(posInMM, separationId, isDisc);
      }

      if (stopDragNDrop === true) {
        if (isDisc !== true) {
          this.previewDiscForNeighbours(posInMM, separationId);
        }
        return;
      }

      this.previewDiscForStep(posInMM, separationId);

      if (isDisc !== true) {
        this.previewDiscForNeighbours(posInMM, separationId);
      }

      this.$refs["separation" + separationId][0].innerHTML = posInMM;
      this.$refs["separation" + separationId][0].style.left = newPos + "px";

      if (
        this.$refs["disc" + separationId] &&
        this.$refs["disc" + separationId][0]
      ) {
        this.$refs["disc" + separationId][0].style.left = newPos + "px";
      }

      if (isDisc === true && nextSeparation != null) {
        let nextSeparationNode = this.$refs["separation" + nextSeparationId][0];

        newPos = clientX - this.separationPosStart + nextSeparation.left;
        nextSeparationNode.style.left = newPos + "px";

        posInMM =
          Math.ceil(
            ((newPos - this.separationAddLeft) / this.separationFactor) * 20
          ) / 20;
        nextSeparationNode.innerHTML = posInMM;

        if (
          this.$refs["disc" + nextSeparationId] &&
          this.$refs["disc" + nextSeparationId][0]
        ) {
          this.$refs["disc" + nextSeparationId][0].style.left = newPos + "px";
        }

        this.previewDiscForNeighbours(posInMM, nextSeparationId);
      }
    },
    previewDiscForNeighbours: function (posInMM, separationId) {
      posInMM = parseFloat(posInMM);
      separationId = parseInt(separationId);

      let currentDiscId = separationId - 1;
      let nextDiscId = separationId;

      if (this.getVerticalDiscs[nextDiscId]) {
        let nextDiscNode = this.$refs["discWidth" + nextDiscId];
        if (nextDiscNode) {
          let widthTillDisc = this.getWidthTillDisc(currentDiscId);
          let widthDiff = widthTillDisc - posInMM;

          let nextDiscWidth = (
            this.getVerticalDiscs[nextDiscId].width + widthDiff
          ).toFixed(2);
          nextDiscNode[0].innerHTML = nextDiscWidth;
        }
      }
    },
    getWidthTillDisc: function (tillDiscId) {
      let discWidth = 0;
      for (let i in this.getVerticalDiscs) {
        if (i <= tillDiscId) {
          discWidth += this.getVerticalDiscs[i].width;
        }
      }
      return discWidth;
    },
    getItemnumberForPlan: function () {
      return this.set.itemnumbers[this.currentItemId]
        ? this.set.itemnumbers[this.currentItemId]
        : this.set.itemnumbers[0];
    },
  },
  updated() {
    if (this.possibleItems.list && this.possibleItems.list.muster) {
      if (
        Object.keys(this.possibleItems.list.muster).length <
        this.maxItems + 1
      ) {
        this.all = true;
      }
    }

    this.currentItemId = SetData.getters.getCurrentItemId;

    if (
      (this.itemData.description || this.itemData === "all") &&
      this.possibleItems.list &&
      this.possibleItems.list.discs &&
      this.possibleItems.list.discs.separations
    ) {
      this.$refs["profile-plan"].setAttribute(
        "src",
        this.getApiHost +
          "/v2/images/profile/" +
          this.getItemnumberForPlan() +
          ".jpg"
      );
      this.setSeparationStartValues();
    }
  },
  computed: {
    verticalDiscsAvailable: function () {
      return (
        this.possibleItems.list.discs &&
        (this.possibleItems.list.discs.position === "vertical" ||
          (this.possibleItems.list.discs.addPartition.position === "vertical" &&
            this.possibleItems.list.discs.addPartition.discs.length > 0))
      );
    },
    getVerticalSeparations: function () {
      if (this.possibleItems.list.discs.position === "vertical") {
        return this.possibleItems.list.discs.separations;
      } else {
        return this.possibleItems.list.discs.addPartition.separations;
      }
    },
    getVerticalDiscs: function () {
      let verticalDiscs = {};
      if (
        this.possibleItems.list.discs &&
        this.possibleItems.list.discs.discs
      ) {
        if (this.possibleItems.list.discs.position === "horizontal") {
          verticalDiscs = this.possibleItems.list.discs.addPartition.discs;
        } else {
          verticalDiscs = this.possibleItems.list.discs.discs;
        }
      }
      return verticalDiscs;
    },
    isAllactionDragNdrop: function () {
      if (isNaN(this.currentItemId)) {
        let set = SetData.getters.getSet;
        if (typeof set.items === "object") {
          let width = 0;
          for (let numericKey in set.items) {
            if (width === 0) {
              width = set.items[numericKey].description.width;
            } else {
              if (width !== set.items[numericKey].description.width) {
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    allocationList: function () {
      let list = {};

      if (this.possibleItems.list && this.possibleItems.list.muster) {
        let counter = 0;

        let length = Object.keys(this.possibleItems.list.muster).length;
        let maxItems = length < this.maxItems + 1 ? length : this.maxItems;

        for (let key in this.possibleItems.list.muster) {
          if (this.all === true || counter < maxItems) {
            list[key] = this.possibleItems.list.muster[key];
            counter++;
          }
        }
      }
      return list;
    },
    isAddDiscAllowed: function () {
      if (this.possibleItems.list.discs) {
        if (
          Object.keys(this.possibleItems.list.discs.discs).length < 10 &&
          this.possibleItems.list.discs.ringType <= 10
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getTotalSeparations: function () {
      let numberSeparations = 0;

      let separations;
      if (this.possibleItems.list.discs.position === "vertical") {
        separations = this.possibleItems.list.discs.separations;
      } else {
        separations = this.possibleItems.list.discs.addPartition.separations;
      }

      let firstSeparationId = null;
      // eslint-disable-next-line no-unused-vars
      for (let separationId in separations) {
        if (firstSeparationId == null) {
          firstSeparationId = separationId;
        }
        numberSeparations++;
      }

      if (firstSeparationId == 2) {
        numberSeparations++;
      }

      return numberSeparations;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .show-hide-presets {
    margin-top: -1rem;
    padding-right: 3rem;
    padding-bottom: 1rem;
    cursor: pointer;
  }

  .icon {
    margin-top: 1rem;
  }

  h4 {
    font-weight: bold;
    font-size: 1em;
  }

  h4 {
    margin-bottom: 1.5em;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 1em;
    text-align: center;

    li {
      display: inline-block;
      margin: 1em 0.5em;
      width: 6em;
      vertical-align: top;
      cursor: pointer;

      @media (min-width: 992px) and (max-width: 1199px) {
        margin: 1em 0.1em;
      }

      img.thumb {
        width: 4em;
        height: 4em;
      }

      span.allocation-name {
        display: inline-block;
        width: 6em;
      }
    }

    li.match {
      font-weight: bold;
      background-color: inherit;

      span.allocation-name {
        color: $black;
      }

      img {
        border: solid 0.2rem $brandGold;
      }
    }
  }

  div.disc-list {
    margin-top: 1em;

    div {
      p {
        font-size: 1em;
        margin: 0;
        padding: 0.2em 0 0 0;
        line-height: 3em;
      }

      select {
        margin-top: 0.6em;
      }

      .thumb {
        margin: 0.1em 0 0 0;
        width: 3.5em;
        height: 3.5em;
      }
    }

    div.add-line {
      .icon {
        margin: 1em;
        padding: 0;
      }

      p {
        line-height: 3em;
        color: $borderColor;
      }
    }
  }

  #SeparationPlan {
    position: relative;
    margin-top: 2rem;

    #SeparationParts {
      position: relative;
      display: inline-block;
      width: 357px;
    }

    .separation {
      position: absolute;
      padding-left: 2px;
      border-left: 2px solid rgb(0, 0, 0);
      margin-top: 1.5rem;
      text-align: left;
      cursor: move;
    }

    .disc {
      position: absolute;
      margin-top: 4rem;
      cursor: move;
    }

    .profile-plan {
      max-width: 30rem;
      max-height: 23rem;
      margin-top: 6rem;
      margin-left: 2.75rem;
    }
  }

  #DragDropIcon {
    display: none;
    width: 20rem;
  }
}
</style>
